import {httpResource} from "@/resources/http.resource";
import store from "@/store/store";
import {IFindDriver} from "@/modules/FindDriver/interfaces/find-driver.interface";

export class FindDriverResource {
  async getInfoByNumber(carNumber: string) {
    let asyncAction = async () => {
      const action = IFindDriver.Action.FindDriver;
      let params: any = {
        carNumber,
      };
      let response = await httpResource.httpAction({ action, params });
      return response.data.result.findDriverInfo;
    };

    let { response } = await store.dispatch('defaultResourceAction', { asyncAction });
    return response;
  }
}

export const findDriverResource: FindDriverResource = new FindDriverResource();